module.exports = __webpack_public_path__ + "img/BMC_EJMR_cover.84ed8607.jpg";